export const EXAMPLE_URL = 'https://example.com/payments';
